import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
  connect() {
    // Auto-dismiss after 5 seconds
    this.timeout = setTimeout(() => {
      this.remove()
    }, 5000)
  }

  disconnect() {
    // Clear timeout if element is removed before auto-dismiss
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  remove() {
    // Add fade-out animation class
    this.element.classList.add("opacity-0", "transition-opacity", "duration-300")

    // Remove element after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
